import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';

export const InfoRow = styled.div<{ forceInline?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin-top: ${({ theme }) => theme.spacing(1)};
  > div {
    flex-basis: 100%;
  }
`;

export const DetailedRequest = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const ExpandWrapper = styled.div`
  margin: ${({ theme }) => `0 0 ${theme.spacing(1.5)}`};
  > a {
    margin-top: ${({ theme }) => theme.spacing(1.5)};
  }
`;

export const RecentActivity = styled.div`
  > div ~ div {
    color: ${({ theme }) => theme.colors.neutrals.grey3};
  }
`;
